import { atom } from 'jotai'

export const stepperAtom = atom(1)

export const chosenDateAtom = atom(null)

export const userDataAtom = atom(false)

export const isErrorAtom = atom(false)
